import { googleAnalyticsEvent } from 'shared/util/analytics'
import log from 'shared/util/log'

export const CATEGORY = 'Video Player'

export type VideoGAActions =
    | 'complete'
    | 'firstQuartile'
    | 'midpoint'
    | 'mute'
    | 'pause'
    | 'playerCollapse'
    | 'playerExpand'
    | 'start'
    | 'thirdQuartile'
    | 'unmute'
    | 'unmute'
    // custom
    | 'Share Sheet On'
    | 'Share Sheet Off'
    | 'Facebook Share'
    | 'Instagram Share'
    | 'Reddit Share'
    | 'Pinterest Share'
    | 'Twitter Share'

export const trackEvent = (action: VideoGAActions, label) => {
    // to avoid refactoring facebook, reddit, pinterest, twitter use those strings
    log.info(`${CATEGORY} GA Event - action: ${action}, label: ${label}`)
    googleAnalyticsEvent({
        category: CATEGORY,
        action,
        label,
    })
}
